import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { MathUtils } from 'three';
import { toggleClara } from '../store/slice/claraSlice';
import { EXPLORE_ROOM } from '../rooms/RoomNameConstants';

const Clara3D = () => {
    const currentRoom = useSelector((state) => state.room.history[0].ID);
    const claraStatus = useSelector((state) => state.clara.status);
    const currentUserData = useSelector((state) => state.user.data);
    const inVRMode = useSelector((state) => state.private.device.inVRMode);
    const inCooperative = useSelector((state) => state.private.device.cooperative);
    const room = useSelector((state) => state.room);

    const iAmTheOwner = currentUserData.socketId === room.roomCreator?.socketId;
    const collidable = inCooperative ? (iAmTheOwner ? "collidable" : "") : "collidable"

    const dispatch = useDispatch();

    const handleToggleClara = () => dispatch(toggleClara())

    let position = { x: -3.5, y: 1.6, z: 1 };
    let hands = {};
    let rotation = "0 70 0";
    let line = {};

    if (position) {
        if (position.x != null) {
            line.start = position.x + " " + (position.y - 0.35) + " " + position.z;
            position = position.x + " " + position.y + " " + position.z;
        }
        if (rotation._x != null) {
            rotation =
                MathUtils.radToDeg(rotation._x) +
                " " +
                MathUtils.radToDeg(rotation._y) +
                " " +
                MathUtils.radToDeg(rotation._z);
        }
        if (hands.end) {
            line.end = hands.end.x + " " + hands.end.y + " " + hands.end.z;
        }
    }

    return inVRMode && currentRoom !== EXPLORE_ROOM ? <a-entity class="Player">
        <a-entity position={position} rotation={rotation}>
            <a-entity
                position="2.19 -1 -2"
                rotation="0 185 0"
                scale="0.3 0.3 0.3"
            >
                <a-box
                    color="#525252"
                    class={collidable}
                    height="3"
                    width="3"
                    depth="2.6"
                    opacity={0}
                    position="0 1.5 0"
                    onClick={handleToggleClara}
                />
                <a-obj-model
                    shadow=""
                    rotation="0 0 0"
                    src={"#" + claraStatus + "-obj"}
                    mtl={"#" + claraStatus + "-mtl"}
                />
            </a-entity>
        </a-entity>
    </a-entity> : null;
}

export default Clara3D
